import LogicaAPI from "./logicaapi";

export default class Attributes extends LogicaAPI {
  genreAttributes({ ids }) {
    const params = {
      datasource: "decorator",
      with_total_count: true,
      condition: {
        id: ids,
      },
    };
    return this.post("/api/v1/attributes/dsearch", { body: params });
  }
}
